import React from 'react';

function icon() {
	const icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="24"
			height="24"
		>
			<rect x="2" y="2" width="20" height="20" rx="3" fill="#008080" />
			<rect x="4" y="8" width="7" height="8" rx="1" fill="white" />
			<rect x="13" y="8" width="7" height="8" rx="1" fill="white" />
			<path
				d="M7 12 L9 12 M8 10 L9 12 L8 14"
				stroke="#008080"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
			<path
				d="M16 12 L18 12 M17 10 L18 12 L17 14"
				stroke="#008080"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</svg>
	);
	return icon;
}

export default icon;
